<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <loading-spinner v-if="isLoading"></loading-spinner>

                <v-card v-else>
                    <card-header :title="$t('title.membernews')"></card-header>
                    <v-card-text class="pa-5">
                        <div>
                            <h4 class="font-weight-bold accent--text">{{ post.title }}</h4>
                            <hr class="mt-3 mb-3">

                            <div>
                                <div class="d-flex text-left">
                                    <label class="font-weight-bold mr-2">{{ $t('label.post_writer') }}</label>
                                    <p>
                                        {{ post.member.name }}
                                    </p>
                                </div>
                                <div class="d-flex text-left">
                                    <label class="font-weight-bold mr-2">{{ $t('label.post_created_at') }}</label>
                                    <p>
                                        {{ post.created_at }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3 mb-3">
                            <div>
                                <div v-html="post.content"></div>
                            </div>
                        </div>

                        <div v-if="post.file_path" class="d-flex align-center text-left mt-3">
                            <label class="font-weight-bold mr-2">{{ $t('label.attachment') }}</label>
                            <v-icon class="mr-1">mdi-file-document-outline</v-icon>
                            <span class="text-truncate">{{ attachmentName }}</span>
                            <v-btn icon small color="primary" @click="handleDownload">
                                <v-icon small>mdi-download</v-icon>
                            </v-btn>
                        </div>

                        <hr class="mt-3 mb-3">

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <custom-button v-if="checkEditCondition()" @click="handleEdit" color="primary"
                                :label="$t('button.edit')" size="lg" gradient rounded></custom-button>
                            <custom-button @click="handleClose" color="black" :label="$t('button.close')" size="lg"
                                gradient rounded></custom-button>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <div>
        </div>
    </v-container>
</template>

<script>
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import CardHeader from '@/components/cards/CardHeader.vue';
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';

import { boardApi, fileApi } from '@/api/api';

export default {
    name: "show-membernews",
    components: {
        CardHeader,
        LoadingSpinner,
        CustomButton,
    },
    props: {
        idx: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            isLoading: false,

            post: {
                title: null,
                content: null,
                created_at: null,
                file_path: null,
                down_file_name: null,
                member: {
                    name: null,
                },
            },
        }
    },
    computed: {
        attachmentName() {
            return this.post.down_file_name || (this.post.file_path || '').split('/').pop();
        },
    },
    methods: {
        /**
         * 뒤로가기 
         */
        goBack() {
            this.$router.go(-1);
        },
        async handleDownload() {
            if (!this.post.file_path) return;
            try {
                const response = await fileApi.fileDownload({
                    file_name: this.post.file_path,
                    down_file_name: this.attachmentName,
                });

                if (response && response.status === 200) {
                    const mimeType = response.headers['content-type'];
                    const blob = new Blob([response.data], { type: mimeType });
                    const fileURL = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = fileURL;
                    link.setAttribute('download', this.attachmentName);
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                    URL.revokeObjectURL(fileURL);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('File download failed:', error);
            }
        },
        async handleClose() {
            this.goBack();
        },
        async handleEdit() {
            this.$router.push({
                path: `/posts/membernews/edit/${this.post.idx}`,
            });
        },
        checkEditCondition() {
            const loginUserIdx = this.$store.getters['auth/userId'];

            if (loginUserIdx != this.post.member.idx) {
                return false;
            }
            return true;
        },
        async fetchPost() {
            const post = {
                idx: this.idx,
            }
            try {
                this.isLoading = true;
                const response = await boardApi.getPost(post);

                if (response && response.status === 200) {
                    this.post = response.data.response;
                    return true;
                }

                return false;
            }
            catch {
                this.notifyVue({
                    message: this.$t('alert.failed_request'),
                    style: "danger",
                });
                this.goBack();
                return false;
            } finally {
                this.isLoading = false;
            }
        },

        /* ****************************************************************************************
         * 알럿
         * ****************************************************************************************/
        notifyVue({
            vertical = "top",
            horizontal = "right",
            message = "",
            style = "primary",
            icon = "priority_high",
        } = {}) {
            this.$notify({
                timeout: 8000,
                message: message,
                icon: icon,
                type: style,
                horizontalAlign: horizontal,
                verticalAlign: vertical,
            });
        }
    },
    mounted() {
        this.fetchPost();
    },
}
</script>

<style lang="scss" scoped>
hr {
    border: 1px solid rgba(233, 233, 233, 0.5);
}
</style>